<div class="dialog" *ngIf="order">

  <div class="dialog__header clickable">
    <span style="font-size: 2rem;">Mais Informações</span>
    <mat-icon (click)="onCancel()">close</mat-icon>
  </div>

  <table>
    <thead>
      <tr>
        <th>
          <span>Empresa:</span>
        </th>
        <th>
          <span>Incluído em:</span>
        </th>
        <th>
          <span>Incluído por:</span>
        </th>
        <th>
          <span>Total Previsto:</span>
        </th>
        <th>
          <span>Qt. de Lojas</span>
        </th>
      </tr>
    </thead>

    <tbody>

      <tr>
        <td>
          <span>{{order.company.nome}}</span>
        </td>
        <td>
          <span>{{formatDate(order.info.creationDate)}}</span>
        </td>
        <td>
          <span>{{order.createdBy}}</span>
        </td>
        <td>
          <span>{{formatCurrency(order.info.plannedTotal)}}</span>
        </td>
        <td>
          <span>{{order.info.storeCount}}</span>
        </td>
      </tr>
    </tbody>

  </table>

</div>